// extracted by mini-css-extract-plugin
export default {"chat_list_panel":"ChatListPanel_chat_list_panel__7rhQz","loading_state":"ChatListPanel_loading_state__aC84s","empty_state":"ChatListPanel_empty_state__Sf45L"};